/**
 * Liquid Glass Background Component
 *
 * Provides an animated background with multiple gradient orbs
 * that create a "liquid glass" effect throughout the application.
 */
export function LiquidGlassBackground() {
	return (
		<div className="fixed inset-0 z-0 overflow-hidden pointer-events-none">
			{/* Layer 1: Large turquoise orb (top-right) */}
			<div
				className="absolute -top-60 -right-60 w-[600px] h-[600px] rounded-full blur-3xl opacity-40 dark:opacity-30 animate-pulse"
				style={{
					background:
						"radial-gradient(circle at center, var(--accent-darker) 2%, transparent 30%)",
					animationDuration: "8s",
				}}
			/>

			{/* Layer 2: Medium purple orb (top-right, offset) */}
			{/* <div
				className="hidden md:block absolute top-20 right-20 w-[400px] h-[400px] rounded-full blur-3xl opacity-30 dark:opacity-25"
				style={{ 
					background: "radial-gradient(circle at center, var(--accent) 0%, transparent 60%)"
				}}
			/>
			 */}

			{/* Layer 3: Large orange/primary orb (bottom-left) */}
			<div
				className="absolute -bottom-32 -left-32 w-[650px] h-[650px] rounded-full blur-3xl opacity-40 dark:opacity-35 animate-pulse"
				style={{
					background:
						"radial-gradient(circle at center, var(--primary) 0%, rgba(224, 108, 0, 0.3) 20%, transparent 70%)",
					animationDuration: "10s",
				}}
			/>

			{/* Layer 4: Medium accent orb (bottom-left, offset) */}
			<div
				className="hidden md:block absolute bottom-40 left-40 w-[350px] h-[350px] rounded-full blur-3xl opacity-25 dark:opacity-20"
				style={{
					background:
						"radial-gradient(circle at center, var(--accent-darker) 0%, transparent 60%)",
				}}
			/>
		</div>
	);
}
